module.exports = __webpack_public_path__ + "static/img/10commitments_5.4530ecd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduction/10commitments_5.jpg
// module id = jW6k
// module chunks = 0